import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Axios from "../config/AxiosConfig";
import logo from "../assets/image/Restaurant Icon.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await Axios.post("/super-admin/forgot-password", {
        email,
      });
      toast.success(response.data.message || "OTP sent successfully!", {
        position: "top-right",
      });
      setTimeout(() => {
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
        setLoading(false);
      }, 1000);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send OTP!", {
        position: "top-right",
      });
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-left">
        <img src={logo} alt="App Logo" className="auth-logo" />
        <h2>Forgot your password?</h2>
        <p>No worries, enter your email and we’ll send an OTP.</p>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h3 className="text-center">Forgot Password</h3>
          <form onSubmit={handleForgotPassword}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-success w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>{" "}
                  Sending...
                </>
              ) : (
                "Send OTP"
              )}
            </button>
            <div className="text-center mt-3">
              <a href="/" className="auth-link">
                Back to Login
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
